
import { Component, Vue } from 'vue-property-decorator'
import CloseCrossCtrl from '~/components/common/ctrls/CloseCrossCtrl.vue'
import DashboardButton from '~/components/common/buttons/DashboardButton.vue'
import Icon from '~/components/common/icon/Icon.vue'

const MODAL_NAME = 'LoopTrialExtensionSuccessModal'

@Component({
  name: 'LoopTrialExtensionSuccessModal',
  components: {
    CloseCrossCtrl,
    DashboardButton,
    Icon
  }
})
export default class LoopTrialExtensionSuccessModal extends Vue {
  closeModal = () => {
    this.$modal.hide(MODAL_NAME)
  }
}
